export enum ProfessionsPermissions {
  VIEW_PROFESSIONS = "view_professions",
  CREATE_PROFESSIONS = "create_professions",
  UPDATE_PROFESSIONS = "update_professions",
  DELETE_PROFESSIONS = "delete_professions",
  ARCHIVE_PROFESSIONS = "archive_professions",
}

export const ProfessionsPermissionsText: Record<
  ProfessionsPermissions,
  string
> = {
  [ProfessionsPermissions.VIEW_PROFESSIONS]: "View Professions",
  [ProfessionsPermissions.CREATE_PROFESSIONS]: "Create Professions",
  [ProfessionsPermissions.UPDATE_PROFESSIONS]: "Update Professions",
  [ProfessionsPermissions.DELETE_PROFESSIONS]: "Delete Professions",
  [ProfessionsPermissions.ARCHIVE_PROFESSIONS]: "Archive Professions",
};
